import React, { useState, memo, useCallback, useMemo, useEffect } from 'react';
import images from "./images";
import { Handle, useReactFlow, useStoreApi } from 'reactflow';

function ClusterNode({ data }) {
    const { nodeId, clusterName, id } = data
    return (
        <>
            <label>Cluster {nodeId} - {clusterName}</label>
            <div className='cluster' >
                <img
                    src={images.SettingsGear}
                    height="20px"
                    onClick={() => data.setOpen(clusterName)}
                    className="settings-gear"
                />
            </div>

        </>
    );
}

export default memo(ClusterNode);

